import React, { useState } from 'react';
import {
  Box,
  Button,
  Input,
  Text,
  VStack,
  Field,
  InputGroup,
  Icon,
  Image,
  Link,
  Alert,
  Span,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import BaseProgressCircle from '../../../../components/BaseProgressCircle';
import AuthCard from '../../components/AuthCard';
import EmailIcon from '../../../../assets/email.png';
import LockIcon from '../../../../assets/LockKey.png';
import { FORGOT_PASSWORD } from '@/constants/routes';
import { useNavigate } from 'react-router';

export interface LoginData {
  email: string;
  password: string;
}

interface LoginFormProps {
  onLoginSubmit: (formData: LoginData, setError: (error: string) => void) => Promise<void>;
}

export default function LoginForm ({ onLoginSubmit }: LoginFormProps) {
  const navigate = useNavigate();

  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    values,
    handleChange,
    errors,
    touched,
  } = useFormik<LoginData>({
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: async (formData) => {
      setLoading(true);
      await onLoginSubmit(formData, setError);
      setLoading(false);
    },
  });


  return (
    <AuthCard>
      <form onSubmit={handleSubmit}>
        <VStack align="stretch" gap={4}>
          <VStack gap={4}>
            <Field.Root invalid={touched.email && Boolean(errors.email)}>
              <InputGroup startElement={<Image src={EmailIcon} />}>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  required
                  placeholder='Email ID'
                  borderRadius={15}
                  size='lg'
                />
              </InputGroup>

              <Field.ErrorText>{errors.email}</Field.ErrorText>
            </Field.Root>

            <Field.Root invalid={touched.password && Boolean(errors.password)}>
              <InputGroup startElement={<Image src={LockIcon} />}>
                <Input
                    id="password"
                    name="password"
                    type="password"
                    value={values.password}
                    onChange={handleChange}
                    required
                    placeholder='Password'
                    borderRadius={15}
                    size='lg'
                  />
              </InputGroup>

              <Field.ErrorText>{errors.password}</Field.ErrorText>
            </Field.Root>
          </VStack>

          <Button 
            colorPalette="brand" 
            type="submit" 
            size='lg' 
            w='260px' 
            borderRadius={15} 
            alignSelf='center'
            mt={8}
            disabled={loading}
          >
            {loading ? <BaseProgressCircle /> : "SIGN IN"}
          </Button>

          <Text color="secondary" fontSize={'sm'}>
            Lost your password? {' '}
            <Span 
              onClick={() => navigate(FORGOT_PASSWORD)} 
              cursor="pointer"
              color='brand.solid'
            >
                Reset it
            </Span>
          </Text>

          {error && (
            <Alert.Root status="error">
              <Alert.Indicator />
              <Alert.Title>{error}</Alert.Title>
            </Alert.Root>
          )}
        </VStack>
      </form>
    </AuthCard>
  );
};
